import formatWithCommas from './format-with-commas.js';
import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func formatAsMoney
 * @param {number} value - The amount in dollars to be formatted.
 * @param {object} options - An object containing all optional params including maxDecimals (defaults to 2), minDecimals (defaults to 2), and conversion (if 'fromCents' divides by 100);
 * @return {string}
 * @desc formats a value as a money string with $ sign
 *```js
 * formatAsMoney(1234);
 * // returns "$1,234.00";
 *
 * formatAsMoney(1234, { conversion: 'fromCents' });
 * // returns "$12.34";
 * ```
 * @memberof module:Number
 * @instance
 */
function formatAsMoney(value, { maxDecimals = 2, minDecimals = 2, conversion } = {}) {
    if (checkTypeValidity(['number', 'numericalString'], value)) {
        value = conversion === 'fromCents' ? Number(value) / 100 : Number(value);
        const sign = value < 0 ? '-' : '';
        return `${sign}$${formatWithCommas(Math.abs(value), maxDecimals, minDecimals)}`;
    }
    else {
        return null;
    }
}

export { formatAsMoney as default };
